// This alternate Toc for Home content exists to reduce repetation in the mobile view of the navbar
const tocHomeMobile = [
  {
    name: 'Release Support Policy',
    link: '/home/incorta-release-support-policy',
  },
];

module.exports = tocHomeMobile;
